import React from 'react';
import * as util from '../other/util.js'
import * as Backend from "../backend.js";
import PlanetAbstractView from "./planet-abstract-view.js"
import * as ICONS from "../other/icons.js";

const clamp = (val, min, max) => Math.max(Math.min(val, max), min);

const getAngle = (x, y) => {
    const angle = Math.atan2(y, x);
    const degrees = 180 * angle / Math.PI;
    return (90 + 360 + Math.round(degrees)) % 360;
}

// Shows a 2d map of the galaxy
class GalaxyBrowserView extends util.GameComponent {
    constructor(props) {
        super(props);
        this.state = {};

        // Keep this as regular attributes, because it does not influence the view
        // It controls when to force refreshes (i.e., iff the coords chance, we need to refresh)
        let x = this.props.params.x;
        let y = this.props.params.y;
        this.last_requested = { x: x, y: y };
    }

    refreshState() {
        let x = this.props.params.x;
        let y = this.props.params.y;
        this.last_requested = { x: x, y: y };
        Backend.getGalaxyBrowserInfo(x, y, (res) => {
            this.setState({
                solar_system: res.solar_system,
                galaxy_map: res.galaxy_map,
                fleets: res.fleets,
            });
        });
    }

    render() {
        const x = this.props.params.x;
        const y = this.props.params.y;
        const z = this.props.params.z;

        if (!this.hasCurrentState(x !== this.last_requested.x || y !== this.last_requested.y)) {
            return (<util.LoadingBar2 />);
        }

        const ss = this.state.solar_system;
        const galaxy_map = this.state.galaxy_map;
        const fleets = this.state.fleets;
        const selected_fleet = this.state.selected_fleet;

        if (!galaxy_map) {
            return (<div>
                <pre>Need to research Astronomy to gain access to the galaxy browser.</pre>
                <pre>Hint: Follow the quests, it unlocks soon.</pre>
            </div>);
        }

        return (
            <div>
                <div style={{ display: "flex" }}>
                    <div style={{ flex: "45%" }}>
                        <GalaxyMap galaxyMap={galaxy_map} fleets={fleets}
                            selectedSolarSystem={{ x: x, y: y }} onSelectSolarSystem={(x, y) => this.handleSelectSolarSystem(x, y)}
                            selectedFleet={selected_fleet} onSelectFleet={(fleet) => this.handleSelectFleet(fleet)} />
                    </div>
                    <div style={{ flex: "5%" }} />
                    <div style={{ flex: "45%" }}>
                        {
                            selected_fleet != null
                                ? <FleetInfo fleet={selected_fleet} />
                                : <SolarSystemInfo solar_system={ss} selected={z} />
                        }
                    </div>
                </div>
                <br />
                <br />
                <util.JsonDebug obj={this.state} />
            </div>);
    }

    handleSelectSolarSystem(x, y) {
        this.props.navigate('/game/galaxy-browser/' + x + '/' + y + '/0');
        this.setState({ selected_fleet: null });
    }

    handleSelectFleet(fleet) {
        this.setState({ selected_fleet: fleet });
    }
}

class SolarSystemInfo extends React.Component {

    render() {
        let ss = this.props.solar_system;
        if (!ss) {
            return (<div className="fade-in" key={Math.random()}>
                <pre>Unknown system.</pre>
            </div>);
        }
        let selected_planet = ss.planets[this.props.selected];

        return (
            <div className="fade-in" key={Math.random()}>
                <h2>System: {ss.name}</h2>
                <div>
                    {this.createHistoryHtml()}
                    <br /><br />
                    {this.createPlanetHtml()}
                </div>
                <PlanetAbstractView planet={selected_planet} />
            </div>
        );
    }

    createHistoryHtml() {
        let ss = this.props.solar_system;
        return (<div>
            <span>The "{ss.name}" system was created {util.InGameTime.getAgeAsNiceString(ss.astro_info.dob)} ago.</span>
            {ss.history.map((event, idx) => (<HistoryEvent key={idx} ss={ss} event={event} />))}
        </div>);
    }

    createPlanetHtml() {
        let ss = this.props.solar_system;

        let html = ss.planets.map((p, idx) => {
            return (
                <tr key={idx}>
                    <td>
                        {idx}
                    </td>
                    <td>
                        <util.PlanetLink planet={p} noCoords={true} />
                    </td>
                    <td>
                        <util.PlayerLink playerId={p.owner_id} playerName={p.owner_name} noCoords={true} />
                    </td>
                    <td>
                        {p.points}
                    </td>
                </tr>
            );
        });


        return (
            <table className="generic-list">
                <tbody>
                    {html}
                </tbody>
            </table>
        );
    }
}

class FleetInfo extends React.Component {
    render() {
        let fleet = this.props.fleet;

        if (util.FleetStatus.getFleetStatus(fleet) === "MOVE") {
            const move_step = util.FleetStatus.getMoveStep(fleet);
            const total_flight_duration = move_step.duration;
            const started = move_step.finished - move_step.duration;
            const completed_flight_duration = Date.now() - started;
            const completed_ratio = clamp(completed_flight_duration / total_flight_duration, 0, 1);

            return (
                <div className="fade-in" key={Math.random()}>
                    <h2>Fleet: {fleet.name}</h2>

                    <util.FleetStatus fleet={fleet} />
                    {fleet.finished ? <span>: <util.Timer date={fleet.finished} /></span> : null}

                    <br />
                    From: <util.PlanetLink planet={move_step.origin} showOwner={true} />

                    <br />
                    To: <util.PlanetLink planet={move_step.location} showOwner={true} />

                    <div style={{ marginLeft: "24px", marginRight: "24px", marginTop: "10px" }}>
                        <div className="quest-progress" style={{ width: "200px", textAlign: "center" }}>
                            <div style={{ width: 200 * completed_ratio }}>{Math.round(completed_ratio * 100) + "%"}</div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="fade-in" key={Math.random()}>
                <h2>System: {fleet.name}</h2>
                <p>???????????????</p>
            </div>
        );
    }
}

class GalaxyMap extends React.Component {
    constructor(props) {
        super(props);
        this.width = 500;
        this.height = 500;
        this.selected_solar_system = { x: props.selectedSolarSystem.x, y: props.selectedSolarSystem.y };
        this.ship_image = new Image();
        this.selected_fleet = props.selectedFleet;
        this.ship_image.src = ICONS.OTHER.ship;
    }

    render() {
        return (
            <div>
                <img src={ICONS.PAGES.galaxy_background} alt={""} style={{ position: "absolute", width: this.width, height: this.height, zIndex: -5 }} />
                <canvas id="map_canvas_id" width={this.width} height={this.height} style={{ border: "2px solid gray" }}
                    onWheel={(e) => this.handleWheel(e)}
                    onClick={(e) => this.handleClick(e)}
                    onMouseDown={(e) => this.handleMouseDown(e)}
                    onMouseUp={(e) => this.handleMouseUp(e)}
                    onMouseLeave={(e) => this.handleMouseLeave(e)}
                    onMouseMove={(e) => this.handleMouseMove(e)} />
                <util.JsonDebug obj={this.props.fleets} />
            </div>
        );
    }

    componentDidMount() {
        this.renderer = new GalaxyMapRenderer(this.width, this.height);
        this.renderer.xOffset = 1;
        this.renderer.yOffset = 1;
        this.renderer.scale = 40;
        this.renderer.setup("map_canvas_id");
        setInterval(() => { // Redraw every once in a while to update the fleet positions on the map
            this.draw()
        }, 10000); // 10s
        setTimeout(() => { // Hack to get the fleet image to show up
            this.draw()
        }, 100);
        this.draw();
    }

    draw() {
        const galaxy_map = this.props.galaxyMap;

        // Clamp everything down
        const buffer = 6; // How much should be visible in each direction at least 6
        this.renderer.xOffset = clamp(this.renderer.xOffset, -(galaxy_map[0].length - buffer), this.renderer.canvas.width / this.renderer.scale - buffer);
        this.renderer.yOffset = clamp(this.renderer.yOffset, -(galaxy_map.length - buffer), this.renderer.canvas.height / this.renderer.scale - buffer);

        // Clean old drawing
        this.renderer.clear();

        // Draw the solar systems
        for (let y = 0; y < galaxy_map.length; y++) {
            for (let x = 0; x < galaxy_map[y].length; x++) {
                this.drawCell(galaxy_map[y][x], x, y);
            }
        }

        // Draw the fleets
        this.props.fleets.forEach(fleet => {
            if (util.FleetStatus.getFleetStatus(fleet) === "MOVE") {
                this.drawFleet(fleet);
            }
        });
    }

    drawFleet(fleet) {
        const move_step = util.FleetStatus.getMoveStep(fleet);
        const origin = move_step.origin;
        const destination = move_step.location;
        const direction = { x: destination.x - origin.x, y: destination.y - origin.y };
        const location = this._getFleetLocation(move_step);

        this.renderer.drawLine(origin.x + 0.45, origin.y + 0.45, location.x + 0.45, location.y + 0.45, 2 / 50, "blue");
        this.renderer.drawLine(location.x + 0.45, location.y + 0.45, destination.x + 0.45, destination.y + 0.45, 2 / 50, "red");
        this.renderer.drawImage(location.x + 0.45, location.y + 0.45, 0.45, 0.45, getAngle(direction.x, direction.y), this.ship_image);

        if (this.selected_fleet && this.selected_fleet.id === fleet.id) {
            this.renderer.drawCircleBorderOnly(location.x + 0.45, location.y + 0.45, 0.6, "white", 2 / 50);
        }
    }

    // Cell == solar system
    drawCell(cell, x, y) {
        if (!cell) {
            return;
        }

        const selected = this.selected_fleet == null && (x === Number(this.selected_solar_system.x) && y === Number(this.selected_solar_system.y));

        let has_player_planet = false;
        for (let i = 0; i < util.getGPS().planets.length; i++) {
            let planet = util.getGPS().planets[i];
            has_player_planet |= (planet.x === x && planet.y === y);
        }

        // let has_mission = false;
        // for (let i = 0; i < util.getGPS().missions.length; i++) {
        //     let mission = util.getGPS().missions[i];
        //     has_mission |= (mission.x === x && mission.y === y);
        // }

        let border_color = selected ? "white" : "#707070";
        let bg_color = selected ? "#555555" : "#151515";
        if (has_player_planet) {
            bg_color = "green";
        }

        this.renderer.drawRectWithBorder(x, y, 0.9, 0.9, bg_color, border_color, 2 / 50);
    }

    handleWheel(e) {
        const [x, y] = this._getPositionInCanvas(e);
        const delta = clamp(e.deltaY / 10, -10.0, 10.0);
        const new_scale = clamp(this.renderer.scale + delta, 25, 100);

        // Need to adjust offsets to keep mouse on the same game object. Just math
        this.renderer.xOffset = ((this.renderer.xOffset + this.renderer.twx(x)) * this.renderer.scale / new_scale) - this.renderer.twx(x);
        this.renderer.yOffset = ((this.renderer.yOffset + this.renderer.twy(y)) * this.renderer.scale / new_scale) - this.renderer.twy(y);
        this.renderer.scale = new_scale;

        this.draw();
    }

    handleClick(e) {
        if (this.mouse_moved_during_down_phase) {
            return;
        }

        const [world_x, world_y] = this._getPositionInWorld(e);

        // Click on fleet ?
        for (let idx = 0; idx < this.props.fleets.length; idx++) {
            const fleet = this.props.fleets[idx];
            if (util.FleetStatus.getFleetStatus(fleet) === "MOVE") {
                const move_step = util.FleetStatus.getMoveStep(fleet);
                const location = this._getFleetLocation(move_step);
                location.x = location.x + 0.45;
                location.y = location.y + 0.45;
                const distance = Math.sqrt(Math.pow(location.x - world_x, 2) + Math.pow(location.y - world_y, 2));
                if (distance < 0.3) {
                    this.props.onSelectFleet(fleet);
                    this.selected_fleet = fleet;
                    return this.draw();
                }
            }
        }

        // Click on solar system ?
        const grid_x = Math.floor(world_x);
        const grid_y = Math.floor(world_y);
        if (this.props.galaxyMap[grid_y] != null && this.props.galaxyMap[grid_y][grid_x] != null) {
            this.props.onSelectSolarSystem(grid_x, grid_y);
            this.selected_solar_system = { x: grid_x, y: grid_y };
            this.selected_fleet = null;
            return this.draw();
        }
    }

    handleMouseMove(e) {
        if (this.mouse_down) {
            const [x, y] = this._getPositionInCanvas(e);
            const moved_far_enough = Math.abs(x - this.drag_start.x) > 10 || Math.abs(y - this.drag_start.y) > 10;
            if (!moved_far_enough && !this.mouse_moved_during_down_phase) {
                return;
            }

            this.mouse_moved_during_down_phase = true;
            this.renderer.xOffset += (x - this.drag_start.x) / this.renderer.scale;
            this.renderer.yOffset += (y - this.drag_start.y) / this.renderer.scale;
            this.drag_start.x = x;
            this.drag_start.y = y;
            this.draw();
        }
    }

    handleMouseDown(e) {
        if (e.button === 0) {
            const [x, y] = this._getPositionInCanvas(e)
            this.mouse_down = true;
            this.mouse_moved_during_down_phase = false;
            this.drag_start = { x: x, y: y };
        }
    }

    handleMouseUp(e) {
        if (e.button === 0) {
            this.mouse_down = false;
        }
    }

    handleMouseLeave() {
        this.mouse_down = false;
    }

    _getFleetLocation(move_step) {
        const origin = move_step.origin;
        const destination = move_step.location;
        const total_flight_duration = move_step.duration;
        const started = move_step.finished - move_step.duration;
        const completed_flight_duration = Date.now() - started;
        const completed_ratio = clamp(completed_flight_duration / total_flight_duration, 0, 1);
        const direction = { x: destination.x - origin.x, y: destination.y - origin.y };
        return { x: origin.x + completed_ratio * direction.x, y: origin.y + completed_ratio * direction.y };
    }

    _getPositionInCanvas(e) {
        const rect = e.target.getBoundingClientRect();
        return [e.clientX - rect.left, e.clientY - rect.top];
    }

    _getPositionInWorld(e) {
        const [graphic_x, graphic_y] = this._getPositionInCanvas(e);
        const world_x = this.renderer.twx(graphic_x);
        const world_y = this.renderer.twy(graphic_y);
        return [world_x, world_y];
    }
}

class GalaxyMapRenderer {
    constructor() {
        this.xOffset = 0;
        this.yOffset = 0;
        this.width = 800;
        this.height = 600;
        this.scale = 1;
        this.context = null;
        this.canvas = null;
    }

    // Called by the webgl canvas react.component when it is mounted
    setup(id) {
        this.canvas = document.getElementById(id);
        if (this.canvas == null) throw new Error("NO CANVAS!");
        this.context = this.canvas.getContext('2d');
        if (this.context == null) throw new Error("NO CONTEXT!");

        this.width = this.canvas.width;
        this.height = this.canvas.height;
    }

    font(px, name, bold) {
        return (px * this.scale) + "px " + name;
    }

    // to graphics
    tgx(x) {
        return (this.xOffset + x) * this.scale;
    }

    tgy(y) {
        return (this.yOffset + y) * this.scale;
    }

    // to world / game
    twx(x) {
        return x / this.scale - this.xOffset;
    }

    twy(y) {
        return y / this.scale - this.yOffset;
    }

    clear() {
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }

    drawLine(from_x, from_y, to_x, to_y, width, color) {
        this.context.beginPath();
        this.context.moveTo(this.tgx(from_x), this.tgy(from_y));
        this.context.lineTo(this.tgx(to_x), this.tgy(to_y));
        this.context.strokeStyle = color;
        this.context.lineWidth = width * this.scale;
        this.context.stroke();
    }

    drawImage(x, y, width, height, rotation, image) {
        this.context.save();
        this.context.translate(this.tgx(x), this.tgy(y));
        this.context.rotate(rotation * Math.PI / 180);
        this.context.drawImage(image, -0.5 * width * this.scale, -0.5 * height * this.scale, width * this.scale, height * this.scale);
        this.context.restore();
    }

    drawRect(x, y, width, height, color) {
        this.context.fillStyle = color;
        this.context.fillRect(this.tgx(x), this.tgy(y), width * this.scale, height * this.scale);
    }

    drawRectWithBorder(x, y, width, height, color, colorBorder, borderSize) {
        this.context.beginPath();
        this.context.rect(this.tgx(x), this.tgy(y), width * this.scale, height * this.scale);
        this.context.fillStyle = color;
        this.context.fill();
        this.context.lineWidth = borderSize * this.scale;
        this.context.strokeStyle = colorBorder;
        this.context.stroke();
    }

    drawCircle(x, y, radius, color) {
        this.context.beginPath();
        this.context.arc(this.tgx(x), this.tgy(y), (radius / 2) * this.scale, 0, 2 * Math.PI, false);
        this.context.fillStyle = color;
        this.context.fill();
    }

    drawCircleWithBorder(x, y, radius, color, colorBorder, borderSize) {
        this.context.beginPath();
        this.context.arc(this.tgx(x), this.tgy(y), (radius / 2) * this.scale, 0, 2 * Math.PI, false);
        this.context.fillStyle = color;
        this.context.fill();
        this.context.lineWidth = borderSize * this.scale;
        this.context.strokeStyle = colorBorder;
        this.context.stroke();
    }

    drawCircleBorderOnly(x, y, radius, colorBorder, borderSize) {
        this.context.beginPath();
        this.context.arc(this.tgx(x), this.tgy(y), (radius / 2) * this.scale, 0, 2 * Math.PI, false);
        this.context.lineWidth = borderSize * this.scale;
        this.context.strokeStyle = colorBorder;
        this.context.stroke();
    }

    drawText(x, y, text) {
        this.context.font = this.font(18, "Arial");
        this.context.fillText(text, this.tgx(x), this.tgy(y));
    }
}

class HistoryEvent extends React.Component {
    render() {
        const event = this.props.event;

        switch (event.type) {
            case "PLAYER_GENESIS":
                return <span>It is the initial landing site and since forth the birthplace of <util.PlayerLink playerName={event.player_name} playerId={event.player_id} /> 's great nation.</span>
            default:
                return <span>Unknown Event: {event.type}</span>
        }
    }
}

export default util.withParamsAndNavigation(GalaxyBrowserView);